module.exports = __webpack_public_path__ + "img/purimotto_tut_c1.2cc396d0.jpg";